export default __webpack_public_path__ + "static/media/Filippo Tuena.407d43b1.jpg";